<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="title">Projekte</h5>
      </div>
      <div class="col-md-auto" style="display: flex; align-items: center;">
        <el-checkbox v-model="hideCompleted" @change="getProjects">Erledigte Aufgaben ausblenden</el-checkbox>
      </div>
      <div class="col-md-auto">
        <el-select
          v-model="filterCategory"
          placeholder="Kategorie"
          @change="updateFilterCategory"
        >
          <el-option key="Alle" label="Alle Projekte" value="Alle"></el-option>
          <el-option key="Bau" label="Bau" value="Bau"></el-option>
          <el-option key="Betrieb" label="Betrieb" value="Betrieb"></el-option>
          <el-option key="Büro" label="Büro" value="Büro"></el-option>
          <el-option key="Archiv" label="Archiv" value="Archiv"></el-option>
        </el-select>
      </div>
      <div class="col-md-auto text-right" v-if="role > 1">
        <p-button type="success" @click="addProject()" class="mt-0"><i
            class="bi bi-file-earmark-plus"></i> Neues Projekt</p-button>
      </div>
    </div>
    <draggable 
      class="row pt-3"
      v-model="projects"
      :options="{ animation: 200, handle: '.project-drag-handle' }"
      @end="onProjectDragEnd"
    >
      <div class="col-lg-auto" v-for="project in projects" :key="project.key">

    <div class="card project" :data-project-key="project.key">
      <h5 class="card-header project-header" :style="getProjectStyle(project)">
        <span class="project-drag-handle" title="Projekt verschieben"><i class="bi bi-grip-vertical"></i></span>
        <span @click="editProject(project)" class="project-title-text">{{ project.title }}</span>
      </h5>
      <div class="card-body">
        <draggable 
          v-model="project.tasks"
          :group="{ name: 'tasks', pull: true, put: true }"
          :options="{ animation: 200 }"
          @change="onTaskChange($event, project)"
          class="task-list"
        >
        <div v-for="task in project.tasks" :key="task.key" v-show="!hideCompleted || task.status !== 'erledigt'" class="card task shadow" @click="editTask(project, task)">
          <h6 class="card-header">{{ task.title }}</h6>
          <div class="card-body">            
            <div class="row">
              <div class="col-md-6">
                <el-tag
                  :type="task.status == 'offen' ? 'danger' : task.status == 'in Arbeit' ? 'warning' : task.status == 'erledigt' ? 'success' : 'info'"
                  :closable="false"
                  size="small"
                  v-if="task.status"
                  class="task-tag"
                >
                  {{task.status}}
                </el-tag>
              </div>
              <div class="col-md-6">
                <p class="card-text" v-if="task.dueDate"><b><i class="bi bi-calendar-check"></i></b> {{ task.dueDate }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="card-text" v-if="task.assignedTo"><b><i class="bi bi-person-fill"></i></b> {{ task.assignedTo }}</p>
              </div>
            </div>
          </div>
        </div>
        </draggable>
        <p-button type="neutral" @click="addTask(project.key)" class="mt-0" icon><i
            class="bi bi-plus-lg"></i></p-button>
      </div>
    </div>
    </div>
    </draggable>

    <modal
      :show.sync="showProjectModal"
      headerClasses="justify-content-center"
      modalMaxWidth="600px"
    >
      <h5 slot="header" class="title mb-0" v-if="mode == 'add'">Neues Projekt</h5>
      <h5 slot="header" class="title mb-0" v-if="mode == 'edit'">Projekt bearbeiten</h5>

      <div class="row mt-3">
        <div class="col">
          <label>Titel</label>
          <el-input v-model="editProjectTitle" placeholder="Titel des Projekts" prefix-icon="bi bi-kanban"></el-input>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <label>Kategorie</label>
          <el-select
                      class="select"
                      placeholder="Kategorie"
                      filterable
                      v-model="editProjectCategory"
                      @change="updateFilterCategory"
                    >
                      <el-option
                        class="select"
                        value="Bau"
                        label="Bau"
                        key="Bau"
                      ></el-option>
                      <el-option
                        class="select"
                        value="Betrieb"
                        label="Betrieb"
                        key="Betrieb"
                      ></el-option>
                      <el-option
                        class="select"
                        value="Büro"
                        label="Büro"
                        key="Büro"
                      ></el-option>
                      <el-option
                        class="select"
                        value="Archiv"
                        label="Archiv"
                        key="Archiv"
                      ></el-option>
            </el-select>
          </div>
      </div>
        <div class="row mt-3" v-if="multiLocationMode == 1">
          <div class="col">
            <label>Standorte</label>
            <el-select
              class="select"
              placeholder="Standorte wählen"
              filterable
              multiple
              collapse-tags
              v-model="editProjectLocations"
            >
              <el-option
                v-for="locationOption in locations"
                :key="locationOption.key"
                class="select"
                :value="locationOption.key"
                :label="locationOption.name"
              ></el-option>
            </el-select>
          </div>
        </div>
      <div class="row mt-4">
        <div class="col">
          <label>Farbe</label>
        </div>
      </div>
      <div class="row mt-0 ml-0">
        <div class="col-md-6">
          <el-color-picker v-model="editProjectColor"></el-color-picker>
        </div>
        <div class="col-md-6">
          <p-button type="danger" @click="removeProject()" class="mt-0" v-if="mode == 'edit'"><i
            class="bi bi-trash3"></i> Projekt entfernen</p-button>
        </div>
      </div>
      
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showProjectModal = false; editProjectTitle = ''; editProjectColor = ''; editProjectLocations = []"
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveProject" :disabled="editProjectTitle == null || editProjectTitle == '' || editProjectLocations.length === 0"
            >Speichern</p-button
          >
        </div>
      </template>
    </modal>

    <modal
      :show.sync="showTaskModal"
      headerClasses="justify-content-center"
      modalMaxWidth="600px"
    >
      <h5 slot="header" class="title mb-0" v-if="mode == 'add'">Neue Aufgabe</h5>
      <h5 slot="header" class="title mb-0" v-if="mode == 'edit'">Aufgabe bearbeiten</h5>

      <div class="row mt-3">
        <div class="col">
          <label>Titel</label>
          <el-input v-model="editTaskTitle" placeholder="Titel der Aufgabe" prefix-icon="bi bi-list-task"></el-input>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <label>Beschreibung</label>
          <el-input v-model="editTaskDescription" placeholder="Beschreibung" type="textarea" :rows="3"></el-input>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <label>Status</label>
          <el-select
                    class="select"
                    placeholder="Status"
                    filterable
                    v-model="editTaskStatus"
                  >
                    <el-option
                      class="select"
                      value="offen"
                      label="offen"
                      key="offen"
                    ></el-option>
                    <el-option
                      class="select"
                      value="in Arbeit"
                      label="in Arbeit"
                      key="in Arbeit"
                    ></el-option>
                    <el-option
                      class="select"
                      value="erledigt"
                      label="erledigt"
                      key="erledigt"
                    ></el-option>
                    <el-option
                      class="select"
                      value="warten"
                      label="warten"
                      key="warten"
                    ></el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label>Fälligkeitsdatum</label>
          <el-date-picker
                    v-model="editTaskDueDate"
                    type="date"
                    placeholder="Fälligkeitsdatum"
                    :picker-options="pickerOptions1"
                    format="dd.MM.yyyy"
                  >
                  </el-date-picker>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col">
          <label>Zugewiesen an</label>
          <el-select
                    class="select"
                    placeholder="Mitarbeiter wählen"
                    filterable
                    v-model="editTaskAssignedTo"
                  >
                    <el-option
                      v-for="option in trainer"
                      class="select"
                      :value="option.trainerName"
                      :label="option.trainerName"
                      :key="option.trainerName"
                    >
                    </el-option>
                  </el-select>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col">
          <p-button type="danger" @click="removeTask()" class="mt-0" v-if="mode == 'edit'"><i class="bi bi-trash3"></i> Aufgabe entfernen</p-button>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showTaskModal = false; editTaskAssignedTo = null; editTaskDescription = null; editTaskDueDate = null; editTaskStatus = null; editTaskTitle = null"
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveTask()" :disabled="editTaskStatus == null || editTaskTitle == null || editTaskTitle == ''"
            >Speichern</p-button
          >
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import {
  Table,
  TableColumn,
  Loading,
  Popover,
  MessageBox,
  Input,
  Select,
  Option,
  ColorPicker,
  Tag,
  Checkbox
} from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import firebase from "firebase/compat/app";
import store from "../../../../store";
import locations from "../../../../locationStore";
import { Modal } from "src/components/UIComponents";
import draggable from "vuedraggable";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(ColorPicker);

export default {
  components: {
    MessageBox,
    Modal,
    draggable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Checkbox.name]: Checkbox
  },

  data() {
    return {
      loading: true,
      trainer: [],
      location: store.getters.userlocation,
      role: store.getters.userrole,
      projects: [],
      showProjectModal: false,
      showTaskModal: false,
      editProjectTitle: null,
      editProjectColor: null,
      editProjectHidden: false,
      editProjectId: null,
      editProjectCategory: null,
      editProjectLocations: [],
      editTaskTitle: null,
      editTaskDescription: null,
      editTaskStatus: null,
      editTaskDueDate: null,
      editTaskAssignedTo: null,
      editTaskHidden: false,
      editTaskId: null,
      editTaskProjectId: null,
      filterCategory: "Alle",
      hideCompleted: false,
      mode: "add",
      locations: locations.getters.locations.locations,
      multiLocationMode: process.env.VUE_APP_MULTIPLE_LOCATIONS,
      pickerOptions1: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Heute",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "In 1 Woche",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 2 Wochen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Monat",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getProjects();
    this.getTrainer();
    if (this.multiLocationMode == 0) {
      this.editProjectLocations = [this.location];
    }
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.getProjects();
      }
    );
  },
  methods: {
    normalizeProjectLocations(projectData) {
      if (Array.isArray(projectData.locationID)) {
        return projectData.locationID.filter((locationId) => !!locationId);
      }
      if (typeof projectData.locationID === "string" && projectData.locationID !== "") {
        return [projectData.locationID];
      }
      return [];
    },
    projectIsVisibleForCurrentLocation(projectData) {
      return this.normalizeProjectLocations(projectData).includes(this.location);
    },
    // get all projects from firestore and the tasks from each project (subcollection of project) and store it in projects array
    getProjects() {
      const projectsRef = db.collection("projects");
      var query = null;
      if(this.filterCategory == 'Alle' || this.filterCategory == null) {
        query = projectsRef.where('Hidden', '==', false).where('Category', '!=', 'Archiv').orderBy("Category").orderBy("Order").orderBy("Title");
      } else {
        query = projectsRef.where('Hidden', '==', false).where('Category', '==', this.filterCategory).orderBy("Order").orderBy("Title");
      }
      
      var tasks = [];
      query.get().then((querySnapshot) => {
        this.projects = [];
        querySnapshot.forEach((doc) => {
          const projectData = doc.data();
          if (!this.projectIsVisibleForCurrentLocation(projectData)) {
            return;
          }
          const tasksRef = db
            .collection("projects")
            .doc(doc.id)
            .collection("Tasks");
          tasksRef.where('Hidden', '==', false).get().then((taskSnapshot) => {
            tasks = [];
            
            taskSnapshot.forEach((task) => {
              var created = null;
              var lastUpdated = null;
              var dueDate = null;
              var dueDateRaw = null;
              if (task.data().Created != null) {
                created = moment(new Date(task.data().Created.seconds * 1000)).format("DD.MM.YY").toString();;
              } else {
                created = null;
              }
              if (task.data().LastUpdated != null) {
                lastUpdated = moment(new Date(task.data().LastUpdated.seconds * 1000)).format("DD.MM.YY").toString();;
              } else {
                lastUpdated = null;
              }
              if (task.data().DueDate != null) {
                dueDate = moment(new Date(task.data().DueDate.seconds * 1000)).format("DD.MM.YY").toString();
                dueDateRaw = moment(new Date(task.data().DueDate.seconds * 1000));
              } else {
                dueDate = null;
                dueDateRaw = null;
              }
              tasks.push({
                key: task.id,
                title: task.data().Title,
                description: task.data().Description,
                status: task.data().Status,
                dueDate: dueDate,
                dueDateRaw: dueDateRaw,
                created: created,
                lastUpdated: lastUpdated,
                assignedTo: task.data().AssignedTo,
                order: task.data().Order !== undefined ? task.data().Order : 9999,
              });
            });
            // Sortiere lokal: erst nach Order (falls vorhanden), dann nach Titel
            tasks.sort((a, b) => {
              if (a.order !== b.order) return a.order - b.order;
              return (a.title || '').localeCompare(b.title || '');
            });
            this.projects.push({
              key: doc.id,
              title: projectData.Title,
              color: projectData.Color,
              category: projectData.Category,
              locations: this.normalizeProjectLocations(projectData),
              tasks: tasks,
            });
          });
        });
        this.loading = false;
      });
    },
    getTrainer() {
      // get list of trainers
      const trainerRef = db.collection("trainer");
      trainerRef
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.trainer = [];
          snapshotChange.forEach((doc) => {
            this.trainer.push({
              trainerName: doc.data().Name,
            });
          });
        });
    },
    addProject() {
      this.editProjectTitle = null;
      this.editProjectColor = this.getRandomColor();
      this.editProjectCategory = null;
      this.editProjectLocations = this.location ? [this.location] : [];
      this.mode = "add";
      this.showProjectModal = true;
    },
    saveProject() {
      if (this.mode == "add") {
        // Neues Projekt ans Ende hinzufügen
        const newOrder = this.projects.length;
        db.collection("projects")
          .add({
            Title: this.editProjectTitle,
            Color: this.editProjectColor,
            Category: this.editProjectCategory,
            locationID: this.editProjectLocations,
            Hidden: false,
            Order: newOrder,
            Created: new Date(),
          })
          .then(() => {
            this.showProjectModal = false;
            this.editProjectTitle = null;
            this.editProjectColor = null;
            this.editProjectHidden = false;
            this.editTaskProjectId = null;
            this.editProjectCategory = null;
            this.editProjectLocations = [];
            this.getProjects();
          })
          .catch(() => {
            console.log("Adding project failed");
          });
      } else if (this.mode == "edit") {
        db.collection("projects")
          .doc(this.editProjectId)
          .update({
            Title: this.editProjectTitle,
            Color: this.editProjectColor,
            Category: this.editProjectCategory,
            locationID: this.editProjectLocations,
            LastUpdated: new Date(),
          })
          .then(() => {
            this.showProjectModal = false;
            this.editProjectTitle = null;
            this.editProjectColor = null;
            this.editProjectHidden = false;
            this.editTaskProjectId = null;
            this.editProjectCategory = null;
            this.editProjectLocations = [];
            this.getProjects();
          })
          .catch(() => {
            console.log("Updating project failed");
          });
      }
    },
    addTask(p) {
      this.mode = "add";
      this.editTaskTitle = null;
      this.editTaskDescription = null;
      this.editTaskStatus = "offen";
      this.editTaskDueDate = null;
      this.editTaskAssignedTo = null;
      this.editTaskProjectId = p;
      this.showTaskModal = true;
    },
    saveTask() {
      if (this.mode == "add") {
        // Finde das Projekt und bestimme die Order für die neue Aufgabe
        const project = this.projects.find(p => p.key === this.editTaskProjectId);
        const newOrder = project ? project.tasks.length : 0;
        db.collection("projects").doc(this.editTaskProjectId).collection("Tasks")
          .add({
            Title: this.editTaskTitle,
            Description: this.editTaskDescription,
            Status: this.editTaskStatus,
            DueDate: this.editTaskDueDate,
            AssignedTo: this.editTaskAssignedTo,
            Hidden: false,
            Order: newOrder,
            Created: new Date(),
          })
          .then(() => {
            this.showTaskModal = false;
            this.editTaskTitle = null;
            this.editTaskDescription = null;
            this.editTaskStatus = null;
            this.editTaskDueDate = null;
            this.editTaskAssignedTo = null;
            this.editTaskHidden = false;
            this.getProjects();
          })
          .catch(() => {
            console.log("Adding task failed");
          });
      } else if (this.mode == "edit") {
        db.collection("projects").doc(this.editTaskProjectId).collection("Tasks")
          .doc(this.editTaskId)
          .update({
            Title: this.editTaskTitle,
            Description: this.editTaskDescription,
            Status: this.editTaskStatus,
            DueDate: this.editTaskDueDate,
            AssignedTo: this.editTaskAssignedTo,
            LastUpdated: new Date(),
          })
          .then(() => {
            this.showTaskModal = false;
            this.editTaskTitle = null;
            this.editTaskDescription = null;
            this.editTaskStatus = null;
            this.editTaskDueDate = null;
            this.editTaskAssignedTo = null;
            this.editTaskHidden = false;
            this.getProjects();
          })
          .catch(() => {
            console.log("Updating task failed");
          });
      }
    },
    editProject(p) {
      this.editProjectTitle = p.title;
      this.editProjectColor = p.color;
      this.editProjectId = p.key;
      this.editProjectCategory = p.category;
      this.editProjectLocations = p.locations ? [...p.locations] : [];
      this.mode = "edit";
      this.showProjectModal = true;
    },
    editTask(p, t) {
      this.editTaskTitle = t.title,
      this.editTaskDescription = t.description,
      this.editTaskStatus = t.status
      if(t.dueDateRaw != null) {
        this.editTaskDueDate = moment(t.dueDateRaw).toDate();
      } else {
        this.editTaskDueDate = null;
      }
      this.editTaskAssignedTo = t.assignedTo,
      this.editTaskId = t.key;
      this.editTaskProjectId = p.key;
      this.mode = "edit";
      this.showTaskModal = true;
    },
    removeProject() {
      MessageBox.confirm(
        "Soll das Projekt " + this.editProjectTitle + " wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              // remove project
              db.collection("projects")
                .doc(this.editProjectId)
                .update({
                  Hidden: true,
                });
              this.showProjectModal = false;
              this.getProjects();
            }
          },
        }
      );
    },
    removeTask() {
      MessageBox.confirm(
        "Soll die Aufgabe " + this.editTaskTitle + " wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              // remove task
              db.collection("projects").doc(this.editTaskProjectId).collection("Tasks")
                .doc(this.editTaskId)
                .update({
                  Hidden: true,
                });
              this.showTaskModal = false;
              this.getProjects();
            }
          },
        }
      );
    },
    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color
    },
    getProjectStyle(p) {
      return {
        '--projectColor': p.color,
      };
    },
    updateFilterCategory() {
      this.getProjects();
    },
    // Drag & Drop: Projekte neu anordnen
    onProjectDragEnd() {
      // Update order for all projects in Firestore
      const batch = db.batch();
      this.projects.forEach((project, index) => {
        const projectRef = db.collection("projects").doc(project.key);
        batch.update(projectRef, { Order: index });
      });
      batch.commit().then(() => {
        console.log("Project order updated");
      }).catch((error) => {
        console.error("Error updating project order:", error);
      });
    },
    // Drag & Drop: Aufgaben zwischen Projekten verschieben
    onTaskChange(evt, targetProject) {
      // Handle removed event - mark task with source project
      if (evt.removed) {
        const removedTask = evt.removed.element;
        // Store source project key in the element for later use
        removedTask._sourceProjectKey = targetProject.key;
        removedTask._sourceTaskKey = removedTask.key;
      }
      
      // Handle added event (task was dropped into this project from another)
      if (evt.added) {
        const movedTask = evt.added.element;
        const newIndex = evt.added.newIndex;
        const sourceProjectKey = movedTask._sourceProjectKey;
        const sourceTaskKey = movedTask._sourceTaskKey || movedTask.key;
        
        if (sourceProjectKey && sourceProjectKey !== targetProject.key) {
          // Move task: delete from old project and add to new project
          const oldTaskRef = db.collection("projects").doc(sourceProjectKey).collection("Tasks").doc(sourceTaskKey);
          const newTaskRef = db.collection("projects").doc(targetProject.key).collection("Tasks").doc();
          
          // Get the task data and move it
          oldTaskRef.get().then((doc) => {
            if (doc.exists) {
              const taskData = doc.data();
              taskData.Order = newIndex;
              taskData.LastUpdated = new Date();
              
              // Add to new project
              newTaskRef.set(taskData).then(() => {
                // Delete from old project
                oldTaskRef.delete().then(() => {
                  console.log("Task moved to new project");
                  // Update the task key in local array
                  movedTask.key = newTaskRef.id;
                  // Clean up temporary properties
                  delete movedTask._sourceProjectKey;
                  delete movedTask._sourceTaskKey;
                  // Update order of all tasks in target project
                  this.updateTaskOrder(targetProject);
                });
              });
            }
          }).catch((error) => {
            console.error("Error moving task:", error);
            this.getProjects();
          });
        } else {
          // Clean up temporary properties if any
          delete movedTask._sourceProjectKey;
          delete movedTask._sourceTaskKey;
        }
      }
      
      // Handle moved event (task was reordered within same project)
      if (evt.moved) {
        this.updateTaskOrder(targetProject);
      }
    },
    // Hilfsmethode: Task-Reihenfolge in Firestore aktualisieren
    updateTaskOrder(project) {
      const batch = db.batch();
      project.tasks.forEach((task, index) => {
        const taskRef = db.collection("projects").doc(project.key).collection("Tasks").doc(task.key);
        batch.update(taskRef, { Order: index });
      });
      batch.commit().then(() => {
        console.log("Task order updated");
      }).catch((error) => {
        console.error("Error updating task order:", error);
      });
    }
  },
};
</script>
<style>
.project-header {
  padding-bottom: 10px !important;
  border-bottom: 6px solid var(--projectColor) !important;
  background-color: rgb(235, 234, 234) !important;
  display: flex;
  align-items: center;
}
.project-drag-handle {
  cursor: grab;
  padding-right: 8px;
  color: #999;
}
.project-drag-handle:hover {
  color: #333;
}
.project-drag-handle:active {
  cursor: grabbing;
}
.project-title-text {
  cursor: pointer;
  flex: 1;
}
.project {
  max-width: 100% !important;
  min-width: 300px !important;
}
.btn-project-edit {
  background-color: rgb(235, 234, 234) !important;;
}
textarea.form-control,
.form-group textarea.el-input__inner {
  max-height: 250px !important;
}
.task-tag {
  color: white !important;
}
.task-tag.el-tag--info {
  background-color: #8d8e8e !important;
}
/* Drag & Drop Styles */
.task-list {
  min-height: 50px;
}
.task {
  cursor: grab;
}
.task:active {
  cursor: grabbing;
}
.sortable-ghost {
  opacity: 0.4;
  background-color: #c8ebfb;
}
.sortable-drag {
  opacity: 1;
}
.sortable-chosen {
  background-color: #f0f9ff;
}
</style>
